module.exports = __webpack_public_path__ + "static/bluesafarimain-50801e588b5b70f4692b3e344fb73a40.jpeg";